import { useEffect, useState } from "react";
import Desktop from "./Desktop/desktop";
import Mobile from "./Mobile/mobile";
import "./header.scss";

const Header = (props) => {
  const bgColor = props.pathname === "/sales-course/" ? "rgba(36, 62, 96)" : "";
  // const Desktop = React.lazy(() => import("./Desktop/desktop"));
  // const Mobile = React.lazy(() => import("./Mobile/mobile"));

  // const isSSR = typeof window === "undefined";

  if (typeof window !== "undefined") {
    window.onscroll = () => {
      if (props?.fixAtTop || window.location.pathname == "/") {
        var header = document.getElementById("desk-header");

        if (header) {
          var sticky = header.offsetTop;

          if (window.pageYOffset > sticky) {
            header.classList.add("fixed-top");
          } else {
            header.classList.remove("fixed-top");
          }

          if (window.pageYOffset > 500) {
            header.classList.add("show-apply");
          } else {
            header.classList.remove("show-apply");
          }
        }
      }
    };
  }

  return (
    <div
      className="header-container"
      id="desk-header"
      style={{ backgroundColor: bgColor }}
    >
      <Desktop formLink={props.formLink} pathname={props.pathname} />
      <Mobile />
      {/* {!isSSR && (
        <React.Suspense fallback={<div>React Lazy testing</div>}>
         
        </React.Suspense>
      )} */}
    </div>
  );
};

export default Header;
